<div *ngIf="showNotice" class="cookie-notice">
    <p style="color: black;">
        To give you the best experience we use cookies. 
        <a [routerLink]="['/privacy-policy']" style="color: blue; text-decoration: underline;">Learn More</a>
      </p>
    <button (click)="acceptCookies()">OK</button>
</div>
